import * as FullStory from '@fullstory/browser'

FullStory.init({ orgId: 'o-1ERY7H-na1' })

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$fullstory', { value: FullStory })
  }
}
